<template>
	<div class="container">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>档案管理</el-breadcrumb-item>
			<el-breadcrumb-item>能源分项管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="搜索："  v-if="user.username == 'admin'">
				<el-select size="small" v-model="departmentId" @change="getEnergyTypeConfigList" placeholder="请选择部门">
				   <el-option v-for="item in departmentList"  :key="item.id" :value="item.id" :label="item.departmentName"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="success"  @click="handleyt()">添加能源用途</el-button>
			</el-form-item>
		</el-form>



      <!-- 数据列表 -->
    <el-table size="small" row-key="id" :data="dataList"
       v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" :header-cell-style="this.$store.state.headerCss">
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="department_name" label="部门">
        </el-table-column>
        <el-table-column prop="energy_typeName" label="能源种类" sortable>
        </el-table-column>
        <el-table-column prop="energy_name" label="能源分项">
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="setGs(scope.row)">设置</el-button>
            <el-button size="mini" type="danger" @click="deleteGs(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>


    <el-dialog  title="新增能源用途" :visible.sync="showYongTu" width="35%"  :close-on-click-modal="false">
      <el-form label-width="100px"  :inline="true">
        <el-form-item label="能源用途：">
          <el-input v-model="yongTuForm.energyName" size="small"></el-input>
        </el-form-item>
      </el-form>

    	<div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="showYongTu = false">取 消</el-button>
    		<el-button size="mini" type="primary" :loading="saveLoad" @click="saveYt">确 定</el-button>
    	</div>
    </el-dialog>



			<!-- 新增，编辑能源 对话框 -->
		<el-dialog  title="新增能源分项" :visible.sync="editNyuanFromVisible" width="800px" :close-on-click-modal="false" >
			<el-form label-width="100px"  :inline="true">
        <el-form-item label="当前部门：">
        	<el-select size="small" v-model="departmentId" v-if="user.username == 'admin'">
             <el-option v-for="item in departmentList" :key="item.id" :value="item.id" :label="item.departmentName"></el-option>
        	</el-select>
        </el-form-item>
				<el-form-item >
					<el-select size="small" v-model="eneryType"  placeholder="能源类型" >
						<el-option v-for="item in energyData" :value="item.id" :label="item.value" :key="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
      <el-table style="width: 100%;" border :data="typeList" size="mini" @selection-change="handleSelectionChange" ref="typeTble">
        <el-table-column  type="selection"  width="60">
        </el-table-column>
        <el-table-column type="index"  width="序号">
        </el-table-column>
        <el-table-column  prop="energyName" label="能源用途" >
        </el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="editNyuanFromVisible = false">取 消</el-button>
				<el-button size="mini" type="primary" :loading="saveLoad" @click="saveFx">确 定</el-button>
			</div>
		</el-dialog>


    <!-- 编辑公式 对话框 -->
    <el-dialog title="分类公式管理" :visible.sync="editGs" :close-on-click-modal="false">

    	  <el-form :inline="true"  label-width="80px" label-position="left" >
    			<el-form-item  label="能源种类:" >
    				<el-input size="mini" v-model="energyName" disabled></el-input>
    			</el-form-item>
          <el-form-item  label="能源分项:" >
          	<el-input size="mini" v-model="energyFx" disabled></el-input>
          </el-form-item>
    	  </el-form>
    	  <el-form label-width="80px" label-position="left">
    		  <el-form-item label="输入公式:">
    			<el-input type="textarea" v-model="gs" disabled  :rows="3"></el-input>
    		  </el-form-item>
    	  </el-form>
        <el-form :inline="true">
         <!-- <el-form-item  label="搜索:" >
            <el-input placeholder="请输入计量点名称" size="small" v-model="searchDatas" style="width:260px"></el-input>
          </el-form-item>
          <el-form-item  >
            <el-button size="small" type="primary"  @click="search()">搜索</el-button>
          </el-form-item> -->
          <el-button size="small" type="primary" @click="showNoBindMters">添加</el-button>
          <el-button size="small"  @click="delMeter"  :disabled="!tempDelMeterList.length" >删除</el-button>
        </el-form>

        <p>当前已绑定的计量点</p>
    	  <el-table height="300" style="width: 100% ;margin-top: 10px;" size="small"
        :data="choisData" border v-loading="loadE" ref="tableMeter" @selection-change="setMeterChoise" >
    		  <el-table-column align="center" type="selection" width="50">
    		  </el-table-column>
          <el-table-column label="计量点id" prop="id" width="180"></el-table-column>
    		  <el-table-column label="计量点名称" prop="meterInfo_name" ></el-table-column>

    		  <el-table-column label="所属单元" prop="terminal_name" ></el-table-column>

    	  </el-table>
        <p>数量:{{choisData.length}}</p>
    	  <div slot="footer" class="dialog-footer">
    		<el-button size="mini" @click="editGs = false">取 消</el-button>
    		<el-button size="mini" type="primary" @click="saveFormula(0)" :loading="saveLoad">确 定</el-button>
    	  </div>
    </el-dialog>


    <!-- 添加计量点界面 -->
    <el-dialog :visible.sync="addFormVisible" width="50%" @click='addFormVisible = false'  title="选择计量点" :close-on-click-modal="false">
    	<!-- <el-input size="small" v-model="searchDatas" placeholder="请输入搜索内容" style="margin-bottom: 14px;"></el-input> -->
      <el-form :inline="true">
        <el-form-item  label="选择是否分项:">
          <el-select v-model="energyFrom.isEnergyData" size="small" style="width: 100px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item   >
          <el-input placeholder="请输入计量点名称" size="small"  v-model="energyFrom.meterName"></el-input>
        </el-form-item>
        <el-form-item  >
          <!-- <el-popover  v-model="visible">
          	<el-input  ref="deptInput" class="cp" readonly slot="reference" autosize size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"></el-input>
          	<div >
          		<el-tree v-loading="treeLoad" :data="treeDate"  :expand-on-click-node="false" :highlight-current="true"  @node-click="handleNodeClick"  :props="jzProps"  accordion  node-key='id'>
          			<span class="custom-tree-node" slot-scope="{ node, data }">
          				<span>
          					<i v-if="!data.parentId && !data.isJz"  class="el-icon-office-building"></i>
          					<i v-if="data.parentId"  class="el-icon-location-outline"></i>
          					<i v-if="data.isJz"  class="el-icon-coin"></i>
          					{{ data.departmentName }}
          				</span>
          			</span>
          		</el-tree>
          	</div>
          </el-popover> -->
          <el-select v-model="energyFrom.terminalCode" placeholder="请选择用能单元" size="small" filterable >
              <el-option
                v-for="item in terminalData"
                :key="item.id"
                :label="item.terminalName"
                :value="item.terminalCode">
              </el-option>
            </el-select>

        </el-form-item>

        <el-form-item  >
          <el-button size="mini" type="primary"  :loading="loadMeter" @click="getMeterList()">搜索</el-button>
        </el-form-item>

      </el-form>
    	<el-table size="small" :data="tables" height="500px"  @selection-change="getAddMeterIds" ref='bindTable'
    	 v-loading="loadMeter">
    		<el-table-column type="selection"></el-table-column>
        <el-table-column type="index" ></el-table-column>
    		<el-table-column label="id" prop="id" width="100"></el-table-column>
    		<el-table-column label="计量点名称" prop="meterInfo_name"></el-table-column>
    		<el-table-column label="所属单元" prop="terminal_name" width="200"></el-table-column>
        <el-table-column label="当前所属分项" prop="energy_name" width="200"></el-table-column>


    	</el-table>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click='addFormVisible = false'>取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="addMeters()">确认</el-button>
    	</div>
    </el-dialog>
	</div>
</template>

<script>
  import {getDepartmentTerminalInfoLis,getEnergyTypeList,getTerminalInfoByDepId} from '../../api/energyMG'
  import { getNyfx,addFx,getGs,addFormula,delFormula,getMeterList,saveEnergyDataItem} from '../../api/analysisMG'

	export default {
		data() {
			return {
        addFormVisible:false,
        saveLoad:false,
        setLoading:false,
        loadMeter:false,
        searchDatas:"",
        visible:false,
				dataList: [],
        user:{},
        treeLoad:false,
        departmentId:"",
				typeList: [],
        getJZ:"",
				loading: false,
        editGs:false,
				formInline: {},
				depLoading:false,
				jzProps: {
					children: 'deps',
				},
        yongTuForm:{
          energyName:""
        },
        typePurpose:[],
				nyTitle:'新增',
				editNyuanFromVisible:false,
				energyData:[],
        departmentList:[],
        meterInfoListTemp:[],
				eneryType:"",
        fxIds:'',
        gs:'',
        editData:[],
        energyName:"",
        energyFx:"",
        loadE:false,
        meterIds:"",
        eid:"",
        treeLoad:false,
        getJZ:"",
        treeDate:[],
        choisData:[],
        MeterInfoList:[],
        department_id:"",
        energy_type:"",
        tempAddMeterList:[],
        tempDelMeterList:[],
        jzProps:{
        	label: function( data,node ){
        		//console.log(data)
        	},
        	children: 'deps',
        },
        energyFrom:{
          departmentId:"",
          energyType:"",
          terminalCode:"",
          isEnergyData:"",
          meterName:""
        },
        terminalData:[],
        showYongTu:false
			}
		},
    computed: {
    	tables() {
    		let search = this.searchDatas
    		if (search) {
    			return this.MeterInfoList.filter(data => {
    				return Object.keys(data).some(key => {
    					return String(data[key]).toLowerCase().indexOf(search) > -1
    				})
    			})
    		}
    		return this.MeterInfoList
    	}
    },
		created() {
			this.getJzData()
			this.getEnergy()

			this.$store.dispatch('getEnergyTypeConfig').then( (res) => {
				this.energyData = res
			})
     this.user = JSON.parse(sessionStorage.getItem('userdata'))


     this.getEnergyTypeConfigList();
		},

		methods: {

      handleyt(){

        this.showYongTu= true
        this.yongTuForm.energyName = ''
      },

      getAddMeterIds(e){
        this.tempAddMeterList = e
      },
      delMeter(){

        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( res => {
          this.saveFormula('delete')
        })

      },
      saveYt(){
        saveEnergyDataItem(this.yongTuForm).then(res=>{
          if( res.status == 1){
            this.$message.success('操作成功')
            this.showYongTu = false
          }else{
             this.$message.error('操作失败')
          }
        })
      },
      addMeters(){
      	let arr = this.choisData.concat(this.tempAddMeterList)
      	this.choisData = Array.from(new Set(arr))
      	this.addFormVisible = false
      	this.tempAddMeterList = []
        this.writeGs()
      	this.$refs.bindTable.clearSelection();

      },

      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
              this.departmentList = res.data.menuDepList
              //this.treeDate = this.changeData(res.data.menuDepList)



      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData( data ){
      	data.forEach(item =>{
      		if( item.terminalInfo){
      			if(!item.deps){
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz= true
      				item.deps.push(obj)
      			})
      		}

      		if( item.deps){
      			this.changeData(item.deps)
      		}
      	})

      	return  data
      },

      handleNodeClick(data) {
      	this.getJZ = data.departmentName
        this.energyFrom.terminalCode = data.terminalCode
        this.visible = false
      },

      getEnergy() {
        getEnergyTypeList().then(res => {
          if(res.status == 1){
            this.typeList = res.data.dataList
          }
        })
      },


      getEnergyTypeConfigList(){
        if( this.user.username != 'admin'){
          this.departmentId = this.user.departmentId
        }
        let param = {
          departmentId:this.departmentId
        }
        this.loading = true
        getNyfx(param).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.dataList
          }
        })
      },


			handleEdit(){
				this.editNyuanFromVisible = true
         this.getEnergy()
        this.eneryType = ''
        this.fxIds = ''
        this.$nextTick(()=>{
           this.$refs.typeTble.clearSelection();
        })

			},
			handleSelectionChange(e){
        this.fxIds = e.map(item => item.id).join('-')
      },

      //保存分项
      saveFx(){

        if(this.eneryType == '' ){
          this.$message.info('请选择能源类型')
          return
        }
        if(this.fxIds == ''){
          this.$message.info('请选择能源用途')
          return
        }
        this.saveLoad = true
        let param = {
          departmentId:this.departmentId,
          energyTypeId:this.eneryType,
          energyDataId:this.fxIds
        }
        addFx(param).then(res => {
          this.saveLoad = false
          if(res.status == 1){
            this.$message.success('操作成功！')
            this.getEnergyTypeConfigList()
            this.editNyuanFromVisible = false
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      //获取公式
      setGs(row){
        this.editGs = true
        this.loadE = true
        this.energyName = row.energy_typeName
        this.energyFx = row.energy_name
        this.eId = row.energy_id
        this.gs = ''
        this.department_id = row.department_id
        this.energy_type = row.energy_type
        this.getBindMeters()


        this.terminalData = this.departmentList.filter(item => item.id == this.departmentId)[0].terminalInfo
       
      },

      getBindMeters(){
        let param = {
          departmentId:this.department_id,
          energyType:this.energy_type,
          energyDataItemId:this.eId
        }
        getGs(param).then(res => {
          this.loadE = false
          if( res.status == 1 ){
            this.choisData = res.data.dataList
            if( res.data.dataList.length ){
              this.writeGs()
              this.meterIds = res.data.dataList.join('-')
            }else{
              this.gs = ''
            }

          }
        })
      },


      showNoBindMters(){
        this.addFormVisible = true
        this.getJZ = ''
        this.energyFrom.terminalCode = ""
        this.energyFrom.isEnergyData = ""
        this.energyFrom.meterName = ""
        this.energyFrom.terminalCode = this.terminalData[0].terminalCode
        
        
        console.log(this.terminalData)
        this.getMeterList();
      },

      //获取计量点
      getMeterList(){


        this.energyFrom.departmentId = this.department_id
        this.energyFrom.energyType = this.energy_type
        this.loadMeter = true

        getMeterList( this.energyFrom ).then( res => {
          this.loadMeter = false
          if(res.status == 1 ){
            this.MeterInfoList = res.data.dataList
          }

        })
      },


      setMeterChoise(e){
        this.writeGs()
        this.tempDelMeterList = e.map(item => item.id)
      },


      writeGs(){
        this.gs = '@'+this.choisData.map(item => item.id).join('+@')
      },
      saveFormula(isDelete){
        this.saveLoad = true
        this.meterIds = this.choisData.map(item => item.id).join('-')
        let param = {
          meterInfoId:isDelete ? this.tempDelMeterList.join('-'):this.meterIds,
          energyId:isDelete ? '' : this.eId
        }

        addFormula(param).then(res => {
          this.saveLoad = false
          if(res.status == 1){

             this.$message.success('操作成功！')
            let arr =[]
             if( isDelete ){
              this.choisData.forEach(item =>{
              	if (!(this.tempDelMeterList.indexOf(item.id) > -1)) {
              		arr.push(item)
              	}
              })
              this.choisData = arr
             }else{
               this.editGs = false
             }
          }else{
             this.$message.error('操作失败')
          }
        })
      },

      deleteGs(row){
        let param ={
          id:row.id
        }
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then( ()=> {
          delFormula(param).then( res => {
            if(res.status == 1){
              this.$message.success('操作成功！')
              this.getEnergyTypeConfigList()
            }
          })
        })

      }
		}
	}
</script>

<style scoped>
	.treel{
		padding: 0 20px;
		font-size: 13px;
	}
  .gs{
    height: 100px;
  }
	.treel i{
		font-size: 14px;
	}
	.treel /deep/ .el-tree-node{
		white-space: normal !important;
	}
	.treel /deep/ .el-tree-node__content{
		height: auto;
		padding: 6px 0;
	}

</style>



// WEBPACK FOOTER //
// src/views/archives/energyType.vue